'use client';

import { useMemo } from 'react';
import { WebSocketConnectedView } from './WebSocketConnectedView';
import { WebSocketPollViewPanel } from './WebSocketPollView';
import { WebSocketSentView } from './WebSocketSentView';
import { WebSocketStoppedView } from './WebSocketStoppedView';
import { WebSocketUnknownView } from './WebSocketUnknownView';
import { parseWebSocketExecutionView } from './parse-websocket-execution-view';

type WebSocketClientRendererProps = {
  data: unknown;
  input?: unknown;
  error?: string;
  maxHeight?: string;
};

export function WebSocketClientRenderer({
  data,
  input,
  error,
  maxHeight = '400px',
}: WebSocketClientRendererProps) {
  const view = useMemo(
    () =>
      parseWebSocketExecutionView({
        input,
        output: data,
        error,
      }),
    [data, error, input],
  );

  switch (view.kind) {
    case 'connect':
      return <WebSocketConnectedView view={view} />;
    case 'send':
      return <WebSocketSentView view={view} />;
    case 'poll':
      return <WebSocketPollViewPanel view={view} maxHeight={maxHeight} />;
    case 'stop':
      return <WebSocketStoppedView view={view} />;
    case 'unknown':
      return <WebSocketUnknownView raw={view.raw} error={view.error} />;
    default: {
      const unhandled: never = view;

      return <WebSocketUnknownView error={String(unhandled)} />;
    }
  }
}
